// TODO: create parent api class to use events and news as child

import AxiosConfig from './axios.config';
import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';
import Mustache from "mustache";
import Utility from '../classes/utility';

// import templates for events
const newsItemNoResultsTemplate = require('../../templates/components/stories/news-item-no-results').default;
const newsItemE2Template = require('../../templates/components/stories/news-item-col').default;
const newsItemE2ContainerTemplate = require('../../templates/components/stories/news-item-container-e2').default;
const newsButtonTemplate = require('../../templates/components/stories/news-button').default;
const NewsItemHome = require('../../templates/components/news/home/news-item').default;

interface newsFilter {
    name: string;
    value: string;
}

enum NewsArticleType {
    Mixed,
    NewsOnly,
    LinkMagazineOnly
}

class NewsAPI {
    axiosConfig: typeof AxiosConfig;
    resultsContainer: HTMLElement;
    displayType: string;
    entryPoint: string;
    filters: Array<newsFilter> = [];
    axiosClient: AxiosInstance;
    isFeaturedConflicted: boolean = false;
    featureConflictedIndex: number = 0;
    page: number = 0;

    constructor(resultsContainer: HTMLElement, displayType: string) {
        this.resultsContainer = resultsContainer;
        this.axiosConfig = AxiosConfig;
        this.axiosClient = axios.create(AxiosConfig);
        this.displayType = displayType;
        this.entryPoint = 'news/v1'
    }

    getFilters(): string {
        let self = this;
        let filterString = "";

        this.filters.forEach((filter, index) => {
            if (index !== self.filters.length - 1) {
                filterString += `${filter.value},`;
            } else {
                filterString += `${filter.value}`;
            }
        });
        return filterString;
    }

    getRequestURL(articleType: NewsArticleType, needles: string, strictFilter: boolean, limit: number): string {
        var url = new URL(this.axiosConfig.baseURL);
        let articleTypeUrl = "";
        let needlesUrl = "";
        articleTypeUrl = `/${articleType.toString()}`;
        if (needles) {
            needlesUrl = `/${needles}`;
        }
        if (strictFilter) {
            url.searchParams.append("strictFilter", "true");
        }
        if (limit) {
            url.searchParams.append("limit", limit.toString());
        }
        if(this.page) {
            url.searchParams.append("page", this.page.toString());
        }
        url.pathname = `/api/${this.entryPoint}${articleTypeUrl}${needlesUrl}`;
        return url.href;
    }

    get(articleType: NewsArticleType, needles: string, strictFilter: boolean, limit: number, page: number = 0) {
        let self = this;
        this.page = page;

        // if this element exists for the featured stories/news element, is the href the same as the first API result?
        let featuredA = this.resultsContainer.parentElement.querySelector('a[title]') as HTMLAnchorElement;
        self.axiosClient.get(self.getRequestURL(articleType, needles, strictFilter, limit))
            .then(function (response) {
                if (response.data.data) {
                    // if not displaying on news home, clear html results.
                    if (self.displayType != "home") {
                        self.resultsContainer.innerHTML = "";
                    }
                    let newsItems = response.data.data as Array<any>;
                    // set maxPages data
                    if (response.data.metaData) {
                        self.resultsContainer.dataset.maxPages = response.data.metaData.pages.lastPage;
                    }
                    if (newsItems) {
                        if (newsItems.length > 0) {
                            let selectedContainer = newsItemE2ContainerTemplate;
                            let selectedTemplate = newsItemE2Template;
                            let content = "";
                            let colSize = "col-sm-6";
                            if (self.displayType == "col-sm-4") {
                                colSize = "col-sm-4";
                            } else if (self.displayType == "home") {
                                selectedTemplate = NewsItemHome;
                            }

                            // exception throw if featured news item is in API results
                            try {
                                newsItems.forEach(function(news, index) {
                                    //decode the title and description
                                    if(news.title)
                                    {
                                        news.title = Utility.htmlDecode(news.title);
                                    }
                                    if(news.description){
                                        news.description = Utility.htmlDecode(news.description);
                                    }

                                    // if not in conflicted state, check if GET needs to be
                                    if (!self.isFeaturedConflicted) {
                                        if (featuredA) {
                                            // wrike#967211232 - temp fix .replaceAll("//", "")
                                            // removing the slash within the cms with cause the news directino to not be in the URL
                                            // Issues with double slash appearing on feature news
                                            //TODO: Change to check title?
                                            if (news.url.replaceAll("//", "/") == featuredA.href.replaceAll("//", "/")) {
                                                self.isFeaturedConflicted = true;
                                                self.featureConflictedIndex = index;
                                                throw 'featuredConflicted';
                                            }
                                        }
                                    }

                                    // if is isFeaturedConflicted - ignore first result
                                    if (self.isFeaturedConflicted && index == self.featureConflictedIndex) {
                                        // do not render first result
                                    } else {
                                        news.displayType = colSize;
                                        news.displayDate = new Date(news.recordObj.startDate).toDateString()
                                        // news.title = Utility.htmlDecode(news.title);
                                        // news.description =  Utility.htmlDecode(news.description);
                                        self.resultsContainer.insertAdjacentHTML('beforeend', Mustache.render(selectedTemplate, news));
                                    }
                                });

                            } catch (error) {
                                self.get(articleType, needles, strictFilter, limit + 1);
                            }

                            if (self.displayType != "home") {
                                self.resultsContainer.innerHTML = Mustache.render(selectedContainer, {items: self.resultsContainer.innerHTML});
                                if (self.resultsContainer.dataset.href) {
                                    let link = self.resultsContainer.dataset.href;
                                    let target = self.resultsContainer.dataset.target;
                                    let label = self.resultsContainer.dataset.label;
                                    let selectedContainerRendered = self.resultsContainer.firstChild as HTMLElement;
                                    if (selectedContainerRendered) {
                                        selectedContainerRendered.innerHTML += Mustache.render(newsButtonTemplate, {link: link, target: target, label: label});
                                    }
                                }
                            }
                            window.lazyload.update();
                        } else {
                            // self.resultsContainer.innerHTML = Mustache.render(eventsLandingNoresultsTemplate, {});
                        }
                    }
                }
            })
            .catch(function (error) {
                console.log(error);
                // self.resultsContainer.innerHTML = Mustache.render(newsItemNoResultsTemplate, {});
            });
    }
}

export default NewsAPI;
export {NewsArticleType};